export var WIDTH_CONSTRAINTS = [275, 980];
